import React, { useState } from 'react';
import DemoProjects from './DemoProjects';
import "./Projects.css"
import ProjectsIn from './ProjectsIn';
const Projects = () => {
    const [project,setProject]=useState(DemoProjects)
    console.log(project);
    return (
        <div className="blogs">
            <div className="asdfad" style={{ backgroundImage: "url(Images/header.svg)" }}>
                <div className="svgabout-in">
                    <h1>My All works Here !!</h1>
                </div>
            </div>
            <div className="blogs-in">
                <p className="headdp">Let's take a look over my works ?</p>
                <ProjectsIn/>
                </div>
          
        </div>
    );
};

export default Projects;